export const ADMIN_GRID_COLUMNS = 64
export const ADMIN_GRID_ROWS = 64
export const MAX_GRID_COLUMNS = 64
export const MAX_GRID_ROWS = 32
export const MIN_GRID_COLUMNS = 8
export const MIN_GRID_ROWS = 8
export const DEFAULT_GRID_COLUMNS = 32
export const DEFAULT_GRID_ROWS = 32
export const DOUBLE_DENSITY_THRESHOLD_COLUMNS = 32
export const DOUBLE_DENSITY_THRESHOLD_ROWS = 16